export const ERRORCODE = {
    // tslint:disable-next-line:max-line-length
    '404': { label: 'Return to landing page.', errmsg: 'Page Not Found', value: "We can't seem to find the page you're looking for." },
    '403': { label: 'Access not allowed', errmsg: 'Access not allowed', value: 'Your account does not have the necessary permissions to access this page. Please contact your company administrator to update your permissions.' },
    '401': { label: 'Error', errmsg: 'Access not allowed', value: 'Required roles are not present in the attESSec cookie.' },
    '440': { label: 'Error', errmsg: '', value: 'attESSec cookie is expired.' },
    '500': { label: 'Error', errmsg: 'Something isn\'t working', value: 'Something occurred. Please try after some time.' },
    // tslint:disable-next-line:max-line-length
    'loginFailure': { label: 'Error', errmsg: 'Something isn\'t working', value: 'We were unable to log you in. Check the spelling of your username and password.' },
    'E100': { label: 'Error', errmsg: '', value: 'Insufficient Permission.' },
    'E200': { label: 'Error', errmsg: '', value: 'Service Not Available.' },
    '400': { label: 'Error', errmsg: '', value: 'Bad Request.' },
    'E400': { label: 'Error', errmsg: '', value: 'FAN is not eligible for device management program.' },
    'E401': { label: 'Error', errmsg: '', value: 'No attESSec cookies found.' },
    'E402': { label: 'Error', errmsg: '', value: 'attESSec cookie is found but value is blank.' },
    'E403': { label: 'Error', errmsg: '', value: 'attESSec cookie is expired.' },
    'E404': { label: 'Error', errmsg: '', value: 'Fan Number(s) is/are Missing.' },
    // 'E405': { label: 'Error',errmsg:'', value: 'Required roles are not present in the attESSec cookie.' },
    // tslint:disable-next-line:max-line-length
    'E405': { label: 'Access not allowed', errmsg: 'Access not allowed', value: 'To access this page, ask your representative to verify your permissions for this account.' },
    'E406': { label: 'Error', errmsg: '', value: 'InquireFANByAgreement API is not returning FANS.' },
    'E407': { label: 'Error', errmsg: '', value: 'This account does not have an authorized user for the device management program.' },
    'E408': { label: 'Error', errmsg: '', value: 'This account does not have an authorized user for the device management program.' },
    'E409': { label: 'Error', errmsg: '', value: 'Permisssion(s) is/are not available.' },
    'E410': { label: 'Error', errmsg: '', value: 'User profile is not available.' },
    'E411': { label: 'Error', errmsg: '', value: 'No FAN(s) is/are associated with email that user has entered.' },
    // tslint:disable-next-line:max-line-length
    'E412': { label: 'Error', errmsg: '', value: 'We could not find the account number you entered. Enter a valid account number to continue' },
    'E900': { label: 'Error', errmsg: '', value: 'Unknown Error.' },
    // tslint:disable-next-line:max-line-length
    // 'careError': { label: 'Error',errmsg:'Something isn\'t working', value: 'This FAN is not valid. Please try with different FAN.' }

    'fnabc': {

        '403': {
            label: 'Access not allowed',
            errmsg: 'Access not allowed',
            value: 'Your account does not have the necessary permissions to access this page. Please contact your company administrator to update your permissions.'
        },
        'NO_ELIGIBILITY': {
            label: 'Access not allowed',
            errmsg: 'Access not allowed',
            value: 'Your account does not have the necessary permissions to access this page. Please contact your company administrator to update your permissions.'
        }

    },
    '408': { label: 'Error', errmsg: 'Access Denied'}
};
